module.exports = __webpack_public_path__ + "img/html-evolution-16.e00c76e1.jpg";